package com.rabbitsign.common

import kotlinx.serialization.Serializable

@Serializable
data class ComplianceReportUrl(val url: String)
